import { render, staticRenderFns } from "./sysOfficeManage.vue?vue&type=template&id=0a97c5c6&"
import script from "./sysOfficeManage.vue?vue&type=script&lang=js&"
export * from "./sysOfficeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports